import { Link } from "react-router-dom";
import headshot from "../../assets/favicon.png";
import "./styles.css";

function Home() {
  return (
    <>
      <h1>
        <Link to={"/about"} className="myName">
          KENNETH BLANTON
        </Link>
      </h1>
      <img src={headshot} alt="" className="headshot" />
      <div className="homeLinks">
        <Link to="/contact">let&apos;s talk</Link>
        <Link to="/projects">my projects</Link>
      </div>
    </>
  );
}

export default Home;
